import React from "react";

import { makeStyles } from 'tss-react/mui';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Checkbox, ListItemText } from "@mui/material";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles()((theme) => {
	return {
		select: {
			"& li": {
				padding: "0px",
				height: "3px"
			},
			padding: "0px",
		},
	}
});



const TicketsQueueSelect = ({
	size,
	userQueues,
	selectedQueueIds = [],
	onChange,
}) => {

	const { classes } = useStyles();

	const handleChange = e => {
		onChange(e.target.value);
	};

	const queuesWithNoQueue = [
		{ id: 'no_queue', name: 'Sem Setor', color: '#000000' },
		...userQueues
	];

	return (
		<FormControl margin="dense" sx={{ marginBottom: '0px', marginTop: '0px' }} fullWidth size="small">
			<Select
				multiple
				displayEmpty
				variant="outlined"
				value={selectedQueueIds}
				onChange={handleChange}
				MenuProps={{
					classes: { paper: classes.select },
					anchorOrigin: {
						vertical: "bottom",
						horizontal: "left",
					},
					transformOrigin: {
						vertical: "top",
						horizontal: "left",
					},
					getcontentanchorel: null,
				}}
				renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
			>
				{queuesWithNoQueue?.length > 0 &&
					queuesWithNoQueue.map(queue => (
						<MenuItem dense key={queue.id} value={queue.id}>
							<Checkbox
								style={{
									color: queue.color,
								}}
								size="small"
								color="primary"
								checked={selectedQueueIds.indexOf(queue.id) > -1}
							/>
							<ListItemText primary={queue.name} />
						</MenuItem>
					))}
			</Select>
		</FormControl>
	);
};

export default TicketsQueueSelect;
